const setCookie = (name: string, value: string) => {
  document.cookie = value !== undefined ? `${name}=${value}; Path=/` : `${name}=`;
};

const readCookie = (name: string) => {
  const cookie: string = document.cookie
    .split(";")
    .map((cookieStr) => cookieStr.trim())
    .find((cookieStr) => cookieStr.startsWith(name));

  return cookie && cookie.replace(`${name}=`, "");
};

const setPreferences = (name: string, value: any) => {
  localStorage.setItem("vintom-player/" + name, JSON.stringify(value));
};

const readPreferences = <T = any>(name: string, defaultValue?: T): T => {
  const value = localStorage.getItem("vintom-player/" + name);
  return value ? (JSON.parse(value) as T) : defaultValue;
};

export const Storage = {
  setCookie,
  readCookie,
};

export const Preferences = {
  set: setPreferences,
  read: readPreferences,
};
